import { useState, useEffect, useCallback } from 'react';
import { Ticket } from '../types/ticket';
import GoogleSheetsService from '../services/googleSheets';

export const useTickets = () => {
  const [tickets, setTickets] = useState<Ticket[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const sheetsService = GoogleSheetsService.getInstance();

  const fetchTickets = useCallback(async () => {
    setLoading(true);
    setError(null);
    
    try {
      const data = await sheetsService.getAllTickets();
      console.log("data", data);
      setTickets(data);
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Có lỗi xảy ra');
    } finally {
      setLoading(false);
    }
  }, [sheetsService]);

  const getTicketsByPhone = useCallback(async (phoneNumber: string): Promise<Ticket[]> => {
    setLoading(true);
    setError(null);
    
    try {
      const data = await sheetsService.getTicketsByPhone(phoneNumber);
      return data;
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Có lỗi xảy ra');
      return [];
    } finally {
      setLoading(false);
    }
  }, [sheetsService]);

  const getTicketsByEmail = useCallback(async (email: string): Promise<Ticket[]> => {
    setLoading(true);
    setError(null);
    
    try {
      const data = await sheetsService.getTicketsByEmail(email);
      return data;
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Có lỗi xảy ra');
      return [];
    } finally {
      setLoading(false);
    }
  }, [sheetsService]);

  const refreshTickets = useCallback(async () => {
    setLoading(true);
    setError(null);
    
    try {
      const data = await sheetsService.forceRefresh();
      setTickets(data);
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Có lỗi xảy ra');
    } finally {
      setLoading(false);
    }
  }, [sheetsService]);

  const clearCache = useCallback(() => {
    sheetsService.clearCache();
  }, [sheetsService]);

  useEffect(() => {
    // Auto-fetch on mount
    fetchTickets();
  }, [fetchTickets]);

  return {
    tickets,
    loading,
    error,
    fetchTickets,
    getTicketsByPhone,
    getTicketsByEmail,
    refreshTickets,
    clearCache,
  };
};

